import Vue from 'vue'
import App from './App.vue'
import './assets/css/reset.css';
import ElementUI from 'element-ui';
// import {Message} from 'element-ui';
import './assets/css/theme/index.css';
// import 'element-ui/lib/theme-chalk/index.css';
// import VCharts from 'v-charts'
import router from "./router";
import store from "./store";
import http from "./api/api.js";
import pub from "./util/public.js";
import util from "./util/util.js";
import resvere from "./util/resvere.js";
// resvere
import types from "./util/types.js";
import upload from "./util/upload.js";
import moment from "moment";
import VueQuillEditor from 'vue-quill-editor'
import DateTimeUtils from './util/DateTimeUtils.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)


import VueAnimateNumber from 'vue-animate-number'
Vue.use(VueAnimateNumber)

Vue.use(ElementUI);
// Vue.use(VCharts)
//用来判断按钮是否拥有权限
Vue.prototype.$buttonAuthority = (str) => {
    const menuListRoute = JSON.parse(sessionStorage.getItem("menuListRoute") || {})
    const indexStair = menuListRoute.findIndex(item => item.code == str.split('-')[0])
    if (indexStair != -1) {
        if (menuListRoute[indexStair].children && menuListRoute[indexStair].children.length) {
            //进来说明一共三层 一级菜单 二级页面  三级按钮
            const secondMenu = menuListRoute[indexStair]
            const secondLevel = secondMenu.children.findIndex(item => item.code == str.split('-')[1])

            if (secondLevel == -1) {
                //第二层找不到就直接false没权限
                return false
            } else {
                //找得到第二层就第三层继续循环查找
                const threeMenu = menuListRoute[indexStair].children[secondLevel]
                const threeLevel = threeMenu.children[str.split('-')[2]]
                return threeLevel ? true : false
            }
        } else {
            //否则就是一级菜单页 二级按钮
            const secondMenu = menuListRoute[indexStair]
            const secondLevel = secondMenu.children[str.split('-')[1]]
            return secondLevel ? true : false
        }
    } else {
        return false
    }
}
Vue.prototype.$http = http;
Vue.prototype.$moment = moment;
Vue.prototype.$DateTimeUtils = DateTimeUtils;
Vue.prototype.$public = pub;
Vue.prototype.$util = util;
Vue.prototype.$types = types;
Vue.prototype.$resvere = resvere;
Vue.prototype.$upload = upload;
// console.log(Message.showClose)
// Vue.prototype.$message = Message({showClose:true});

Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')
